"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _map2 = _interopRequireDefault(require("lodash/map"));

var _replace2 = _interopRequireDefault(require("lodash/replace"));

var _split2 = _interopRequireDefault(require("lodash/split"));

var _slice = require("@lce/slice");

var _i18n = require("@lce/i18n");

var _api = require("@lce/api/");

var Styled = _interopRequireWildcard(require("./Links.style"));

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj["default"] = obj;
    return newObj;
  }
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var Links = function Links(_a) {
  var linkArr = _a.linkArr,
      handleOnClose = _a.handleOnClose;

  var _b;

  var t = (0, _i18n.useTranslation)()[0]; // tslint:disable-next-line: strict-type-predicates

  var pathName = typeof window !== 'undefined' && (0, _replace2["default"])(window.location.pathname, /\/$/, '') || '';
  var activeRoute = (0, _split2["default"])(pathName, '/').pop();
  var settings = (0, _api.useSettings)().data;
  var isDeals = (_b = settings === null || settings === void 0 ? void 0 : settings.FEATURE) === null || _b === void 0 ? void 0 : _b.DEALS;
  return _react["default"].createElement(_slice.Flex, {
    as: "nav",
    "data-testid": "header__links",
    flex: "1 1 auto",
    flexDirection: "column",
    role: "navigation"
  }, (0, _map2["default"])(linkArr, function (link, key) {
    var linkRoute = (0, _split2["default"])(link.to, '/').pop();
    return _react["default"].createElement(Styled.Link, {
      "data-testid": "header__" + link.id,
      href: "/" + link.to,
      id: link.id,
      isactive: activeRoute === linkRoute ? 1 : 0,
      key: link.to,
      onClick: handleOnClose,
      tabIndex: key + 1,
      title: t(link.label)
    }, t(link.label));
  }), isDeals && _react["default"].createElement(Styled.Link, {
    "data-testid": "header__deals",
    href: "/deals",
    id: "click-deals",
    isactive: activeRoute === 'deals' ? 1 : 0,
    key: "deals",
    onClick: handleOnClose,
    tabIndex: linkArr.length + 1,
    title: "Deals"
  }, t('Header.AccountLinks.Deals')));
};

var _default = Links;
exports["default"] = _default;